module.exports = __webpack_public_path__ + "img/selected6-min.1ead15b6.png";